"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.object.assign.js");
var _babelHelperVueJsxMergeProps = _interopRequireDefault(require("@vue/babel-helper-vue-jsx-merge-props"));
var _utils = require("../utils");
var _functional = require("../utils/functional");
var _router = require("../utils/router");
var _loading = _interopRequireDefault(require("../loading"));
var _icon = _interopRequireDefault(require("../icon"));
// Types

var _use = (0, _utils.use)('button'),
  sfc = _use[0],
  bem = _use[1];
function Button(h, props, slots, ctx) {
  var icon = props.icon,
    zziconfont = props.zziconfont,
    classPrefix = props.classPrefix,
    tag = props.tag,
    type = props.type,
    size = props.size,
    disabled = props.disabled,
    loading = props.loading,
    style = props.style,
    btnClass = props.btnClass,
    plain = props.plain;
  var isHairline = plain || !(type === 'primary' || type === 'gray' || type === 'info' || type === 'text' || type === 'link');
  var text = slots.default ? slots.default() : props.text;
  var loadingText = props.loadingText || text;
  var subText = size !== 'small' && props.subText;
  var subTextSlot = slots.subText ? slots.subText() : '';
  var onClick = function onClick(event) {
    if (disabled) {
      event.preventDefault();
    }
    if (!loading && !disabled) {
      (0, _functional.emit)(ctx, 'click', event);
      (0, _router.functionalRoute)(ctx);
    } else if (loading) {
      (0, _functional.emit)(ctx, 'loading-click', event);
    } else if (disabled) {
      (0, _functional.emit)(ctx, 'disabled-click', event);
    }
  };
  var onTouchstart = function onTouchstart(event) {
    (0, _functional.emit)(ctx, 'touchstart', event);
  };
  var classes = [bem([type || 'default', size, {
    loading: loading,
    disabled: disabled,
    hairline: isHairline,
    icon: icon || loading,
    block: props.block,
    plain: props.plain,
    round: props.round,
    square: props.square
  }]), {
    'z-hairline--surround': isHairline
  }];
  return h(tag, (0, _babelHelperVueJsxMergeProps.default)([{
    "class": [classes, btnClass],
    "attrs": {
      "type": props.nativeType
    },
    "on": {
      "click": onClick,
      "touchstart": onTouchstart
    },
    "style": style
  }, (0, _functional.inherit)(ctx)]), [h("span", {
    "class": bem('text', (subText || subTextSlot) && 'with-sub')
  }, [h("span", {
    "class": bem('text-main')
  }, [loading && h(_loading.default, {
    "class": bem('icon'),
    "attrs": {
      "size": props.loadingSize
    }
  }), icon && !loading && h(_icon.default, {
    "class": bem('icon'),
    "attrs": {
      "name": icon,
      "class-prefix": classPrefix || (zziconfont ? 'zziconfont' : undefined)
    }
  }), h("span", [loading ? loadingText : text]), type === 'link' && h(_icon.default, {
    "attrs": {
      "name": "arrow-right",
      "class-prefix": "zziconfont"
    }
  })]), subTextSlot, subText && h("span", {
    "class": bem('text-sub')
  }, [subText])])]);
}
Button.props = Object.assign({}, _router.routeProps, {
  icon: String,
  zziconfont: Boolean,
  // 兼容旧写法
  classPrefix: String,
  text: String,
  subText: String,
  plain: Boolean,
  block: Boolean,
  round: Boolean,
  square: Boolean,
  loading: Boolean,
  disabled: Boolean,
  nativeType: String,
  loadingText: String,
  tag: {
    type: String,
    default: 'button'
  },
  type: {
    type: String,
    default: 'default'
  },
  size: {
    type: String,
    default: 'normal'
  },
  loadingSize: String,
  style: Object,
  btnClass: [String, Array]
});
var _default = sfc(Button);
exports.default = _default;